import EventDispatcher from "../managers/EventDispatcher";


export default class Component extends EventDispatcher {

    // constructor
    constructor (args = {}) {

        // call super
        super(args);

        // set properties
        this._$el = args.$el;
        this._isReady = false;
    }

    // methods

    // getters & setters
    get $el () {
        return this._$el;
    }

    get isReady () {
        return this._isReady;
    }

    set isReady (value) {
        if (value !== this._isReady) {
            this._isReady = value;
            this._$el.classList.toggle('--is-ready', value);
            this.dispatchEvent(value ? 'ready' : 'not-ready');
        }
    }
}

// utils

// listeners